export const pointTableConfig = {
  propList: [
    {
      prop: 'reason',
      label: '原因',
      minWidth: '60'
    },
    {
      prop: 'num',
      label: '金币数量',
      minWidth: '60'
    },
    { prop: 'remark', label: '备注', minWidth: '120' },
    {
      prop: 'createdTime',
      label: '操作时间',
      minWidth: '100',
      slotName: 'createdTime'
    }
  ]
}
